import { render, staticRenderFns } from "./section-list.vue?vue&type=template&id=4de54ad7&scoped=true&"
import script from "./section-list.vue?vue&type=script&lang=ts&"
export * from "./section-list.vue?vue&type=script&lang=ts&"
import style0 from "./section-list.vue?vue&type=style&index=0&id=4de54ad7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de54ad7",
  null
  
)

export default component.exports